
import ajax from "./ajax";

export const listByPage = params => ajax(`/cooperation/listByPage`, params,'POST');
export const insert = params => ajax(`/cooperation/insert`, params,'POST');
export const update = params => ajax(`/cooperation/update`, params,'POST');
export const del = params => ajax(`/cooperation/delete`, params,'POST');
export const querySingle = params => ajax(`/cooperation/querySingle`, params,'POST');


export const insertJoin = params => ajax(`/joinApplication/insert`, params,'POST');






























